import React, { useEffect, useState } from "react";
import { genericGet } from "../../services/apiServices";
import { GET_COMPANY } from "../../services/apiRoutes";
import { getDefaultCompanyList } from "../../services/CommonServices";

const CustomReportPrint = ({
    title,
    columns = [],
    tableData = [],
    fromDate = "",
    toDate = "",
}) => {
    const [selectedCompany, setSelectedCompany] = useState(null);
    useEffect(() => {
        fetchDefaultCompany();
    }, []);
    const fetchDefaultCompany = async () => {
        const { defaultCompany } = await getDefaultCompanyList();
        setSelectedCompany(defaultCompany);
    };
    return (
        <div
            style={{
                fontSize: "14px",
                padding: "20px",
                fontFamily: "Poppins, sans-serif",
            }}
        >
            {/* ================= COMPANY HEADER ================= */}
            {selectedCompany && (
                <div
                    style={{
                        position: "relative",
                        padding: "0px",
                        marginTop: "10px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                        }}
                    >
                        {/* Company Name */}
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                margin: 0,
                                textTransform: "uppercase",
                            }}
                        >
                            {selectedCompany.name}
                        </p>

                        {/* Company Address */}
                        <p
                            style={{
                                fontSize: "12px",
                                margin: "2px 0",
                            }}
                        >
                            {selectedCompany.address}, {selectedCompany.city},{" "}
                            {selectedCompany.state}, {selectedCompany.country} -{" "}
                            {selectedCompany.pincode}
                        </p>

                        {/* Company Contact Info */}
                        <p
                            style={{
                                fontSize: "10px",
                                margin: "0px 0 0px",
                            }}
                        >
                            Mobile: {selectedCompany.mobile} | Email:{" "}
                            {selectedCompany.email} | Website:
                            <a
                                href={selectedCompany.website}
                                style={{
                                    textTransform: "lowercase",
                                    color: "black",
                                    textDecoration: "none",
                                    marginLeft: "3px",
                                }}
                            >
                                {selectedCompany.website}
                            </a>
                        </p>

                        {/* Report/Invoice Title */}
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                margin: "4px 0 0",
                                textTransform: "uppercase",
                                textDecoration: "underline",
                            }}
                        >
                            {title || "Report"}
                        </p>
                    </div>
                </div>
            )}

            {/* ================= DATE RANGE ================= */}
            <div
                style={{
                    textAlign: "center",
                    marginBottom: "20px",
                    fontSize: "12px",
                    color: "#555",
                }}
            >
                {fromDate && toDate ? (
                    <>
                        {fromDate} <strong>to</strong> {toDate}
                    </>
                ) : fromDate ? (
                    <>From: {fromDate}</>
                ) : toDate ? (
                    <>To: {toDate}</>
                ) : (
                    ""
                )}
            </div>

            {/* ================= TABLE ================= */}
            {Array.isArray(tableData) && tableData.length > 0 ? (
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "12px",
                        marginTop: "10px",
                    }}
                >
                    {/* Table Header */}

                    <thead>
                        <tr>
                            {columns
                                .filter(
                                    (col) =>
                                        col.accessorKey?.toLowerCase() !== "action" &&
                                        col.header?.toLowerCase() !== "action"
                                )
                                .map((col, idx) => (
                                    <th
                                        key={idx}
                                        style={{
                                            border: "1px solid #999",
                                            padding: "6px",
                                            backgroundColor: "#f3f3f3",
                                            fontWeight: 600,
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        {col.header || col.accessorKey}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    {/* Table Body */}
                    <tbody>
                        {tableData.map((row, rowIdx) => (
                            <tr key={rowIdx}>
                                {columns
                                    .filter(
                                        (col) =>
                                            col.accessorKey?.toLowerCase() !== "action" &&
                                            col.header?.toLowerCase() !== "action"
                                    )
                                    .map((col, colIdx) => (
                                        <td
                                            key={colIdx}
                                            style={{
                                                border: "1px solid #ccc",
                                                padding: "6px",
                                                textAlign: col?.tableStyle?.textAlign || "center",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {row[col.accessorKey] ?? "-"}
                                        </td>
                                    ))}

                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p
                    style={{
                        color: "gray",
                        marginTop: "20px",
                        textAlign: "center",
                    }}
                >
                    No data available.
                </p>
            )}
        </div>
    );
};

export default CustomReportPrint;
